import Vue from 'vue';
import store from './../../store';
import webSiteService from '../website';

// When the request succeeds
const success = (context, response, rentalsData) => {
  toastr.success(context.$t('account.update_success'));
  store.dispatch('updateAccount', response.user);
  if (rentalsData) {
    webSiteService.getGroupsWithRentals(context, context.users.web_key, true);
  }
};

// When the request fails
const failed = (context, error) => {
  context.showToasterError(error);
};

export default (context, user, rentalsData = null) => Vue.$http.post('/account', user)
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response.data, rentalsData);
      } else {
        failed(context, response);
      }
    })
    .catch((error) => {
      failed(context, error);
    });



// WEBPACK FOOTER //
// ./src/app/services/account/update.js